import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M16.05 10.7001C16.05 10.7001 16.29 21.06 29.48 26.85C39.61 31.3 44.23 29.5401 47.76 33.9901C50.16 37.0201 49.08 42.6501 51.83 50.4901C51.83 50.4901 58 38.2301 55.13 22.2001C52.27 6.17008 40.16 2.04004 33.88 1.22004C28.49 0.520037 20.45 2.16008 17.04 6.14008C17.04 6.14008 8.18004 6.18005 3.77004 17.42C-1.59996 31.11 4.6 50.5001 4.6 50.5001C4.6 50.5001 8.75002 39.73 9.99002 30.02C12.09 13.63 16.05 10.7001 16.05 10.7001Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M18.38 8.79004C18.26 10.8 18.79 12.81 19.84 14.47C20.86 16.15 22.37 17.49 24.06 18.48C24.89 19 25.81 19.37 26.71 19.77C27.63 20.12 28.57 20.4201 29.52 20.6901C30.49 20.9001 31.44 21.1501 32.43 21.3201L35.4 21.8801C39.33 22.7601 43.34 23.55 47.03 25.41C48.84 26.35 50.54 27.7201 51.52 29.5701C52.49 31.4201 52.68 33.52 52.58 35.52C52.46 33.52 52.15 31.4701 51.09 29.8101C50.09 28.1201 48.46 26.92 46.69 26.1C43.1 24.46 39.13 23.66 35.21 22.86C33.25 22.45 31.28 22.0801 29.29 21.5601C27.34 20.9601 25.37 20.3001 23.66 19.1201C21.94 18.0001 20.4 16.5201 19.42 14.7001C18.92 13.8001 18.6 12.8101 18.42 11.8101C18.22 10.8101 18.2 9.78004 18.38 8.79004Z"
        fill={outline}
      />
      <path
        d="M55.6299 26.33C53.9999 14.79 40.9999 16.1 29.7799 15.71C18.5599 15.33 18.3799 8.02002 18.3799 8.02002C18.3799 8.02002 20.3699 13.2101 29.4199 12.2501C38.4699 11.2901 48.4699 7.24006 52.9899 14.9401"
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M16.4899 6.3501C16.4899 6.3501 9.38997 9.1601 7.33997 23.7901C5.44997 37.3001 1.90991 40.3301 1.90991 40.3301"
        stroke={outline}
        strokeMiterlimit="10"
      />
    </g>
  )
}
